import { EMAIL_BRANDING_IMAGE_DIMENSIONS, EMAIL_BRANDING_IMAGE_MAX_BYTES } from '../config/email-branding';

export type EmailBrandingImageValidationResult =
  | { ok: true }
  | { ok: false; message: string };

export async function validateEmailBrandingImageFile(
  file: File
): Promise<EmailBrandingImageValidationResult> {
  if (file.type !== 'image/png') {
    return { ok: false, message: 'Email logo must be a PNG image' };
  }

  if (file.size > EMAIL_BRANDING_IMAGE_MAX_BYTES) {
    return { ok: false, message: 'Email logo must be 5 MB or smaller' };
  }

  // createImageBitmap decodes the File directly without producing a blob: URL,
  // so it isn't subject to the CSP img-src directive (which omits blob:).
  let bitmap: ImageBitmap;
  try {
    bitmap = await createImageBitmap(file);
  } catch {
    return { ok: false, message: 'Could not read image dimensions — file may be corrupt.' };
  }

  try {
    const { width: requiredW, height: requiredH } = EMAIL_BRANDING_IMAGE_DIMENSIONS;
    if (bitmap.width !== requiredW || bitmap.height !== requiredH) {
      return {
        ok: false,
        message: `Email logo must be exactly ${requiredW} x ${requiredH} px. Uploaded file is ${bitmap.width} x ${bitmap.height} px.`,
      };
    }
    return { ok: true };
  } finally {
    bitmap.close();
  }
}
